import { createRouter, createWebHistory } from 'vue-router'
import AppTop from './views/AppTop'
// v2
import V2UserGuideExplanation from './views/v2/Explanation'
import V2UserGuidePrice from './views/v2/Price'
import V2UserGuideQuestionAndAnswer from './views/v2/QuestionAndAnswer'
import V2UserGuideTerms from './views/v2/Terms'
import V2Top from './views/v2/Top'
import V2Charge from './views/v2/Charge'
import V2InitialAgreement from './views/v2/InitialAgreement'
import V2AppTop from './views/v2/AppTop'
import V2Settlement from './views/v2/Settlement'
import V2CardEdit from './views/v2/CardEdit.vue'

const routes = [
  {
    path: '/carwash/moveAppTop',
    name: 'AppTop',
    component: AppTop
  },
  // v2
  {
    path: '/carwash/v2/explanation',
    name: 'V2UserGuideExplanation',
    component: V2UserGuideExplanation
  },
  {
    path: '/carwash/v2/price',
    name: 'V2UserGuidePrice',
    component: V2UserGuidePrice
  },
  {
    path: '/carwash/v2/qa',
    name: 'V2UserGuideQuestionAndAnswer',
    component: V2UserGuideQuestionAndAnswer
  },
  {
    path: '/carwash/v2/terms',
    name: 'V2UserGuideTerms',
    component: V2UserGuideTerms
  },
  {
    path: '/carwash/v2/top',
    name: 'V2Top',
    component: V2Top
  },
  {
    path: '/carwash/v2/initialAgreement',
    name: 'V2InitialAgreement',
    component: V2InitialAgreement
  },
  {
    path: '/carwash/v2/charge',
    name: 'V2Charge',
    component: V2Charge
  },
  {
    path: '/carwash/v2/moveAppTop',
    name: 'V2AppTop',
    component: V2AppTop
  },
  {
    path: '/carwash/v2/settlement',
    name: 'V2Settlement',
    component: V2Settlement
  },
  {
    path: '/carwash/v2/cardEdit',
    name: 'V2CardEdit',
    component: V2CardEdit
  }
]
const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
